import StickerOneForm from './StickerOneForm';

export default {
  StickerOneForm,
};
